var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88412 6.67992C3.70734 6.46778 3.39206 6.43912 3.17992 6.6159C2.96778 6.79268 2.93912 7.10797 3.1159 7.3201L5.34916 10L3.1159 12.6799C2.93912 12.8921 2.96778 13.2073 3.17992 13.3841C3.39206 13.5609 3.70734 13.5322 3.88412 13.3201L6.00001 10.781L8.1159 13.3201C8.29268 13.5322 8.60797 13.5609 8.8201 13.3841C9.03224 13.2073 9.06091 12.8921 8.88412 12.6799L6.65087 10L8.88412 7.3201C9.06091 7.10797 9.03224 6.79268 8.8201 6.6159C8.60797 6.43912 8.29268 6.46778 8.1159 6.67992L6.00001 9.21899L3.88412 6.67992Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14V4.5L7.5 0H2C0.895431 0 0 0.89543 0 2V14C0 15.1046 0.895431 16 2 16H10C11.1046 16 12 15.1046 12 14ZM7.5 3C7.5 3.82843 8.17157 4.5 9 4.5H11V14C11 14.5523 10.5523 15 10 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H7.5V3Z",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.26c1558f7ea55bb0d7fd0b7b4267c75d.svg";
export { ForwardRef as ReactComponent };